/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

const InvoiceGrid = (props) => {
    const [dataGridKey, setDataGridKey] = useState(0); const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const rowsLength = props.rows?.length || 0;
        if (rowsLength > 0) {
            setRows(props.rows);
            setDataGridKey(1);
            let GridColumns
            GridColumns = Object.keys(props.header[0]).filter((key) => key !== 'id').map((key) => ({
                field: key,
                headerName: key,
                flex: 1,
                minWidth:
                    key === "Observacion" ? 800 :
                        (key === "N Factura" || key === "Fecha ingreso" || key === "Identificación") ? 250 :
                            (key === "Turno" || key === "Estado SRI" ) ? 200 : 230,
                headerClassName: 'super-app-theme--header',
                sortable: false,
                renderHeader: (params) => (
                    <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }} className="cabezeraTabla">
                        <div>{key}</div>
                    </div>
                ),
                renderCell: (params) => (
                    <div key={key}>
                        {params.row[key]}
                    </div>
                ),
            }));

            GridColumns[Object.keys(props.header[0]).length] =
            {
                field: 'acciones', headerName: 'Acciones', flex: 1, minWidth: 30, headerClassName: 'super-app-theme--header', sortable: false,
                renderHeader: (params) => (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }} className="cabezeraTabla">
                        <div>Acciones</div>
                    </div>
                ),
                renderCell: (params) => (
                    <>
                        {
                            props.handledVer
                                ?
                                <Tooltip title="Ver Factura" placement="top">
                                    <button
                                        onClick={(e) => props.handledVer(params.row.id)}
                                        className="btn btn-xs"
                                        style={{ backgroundColor: "#ADD8E6", color: "#fff" }}
                                    >
                                        <i
                                            className="nav-icon fas fa-file-pdf"
                                            style={{ color: "#000000" }}
                                        >
                                        </i>
                                    </button>
                                </Tooltip>
                                :
                                ""
                        }

                        {
                            props.handledSend
                                ? <>&nbsp;&nbsp;
                                    <Tooltip title="Enviar al cliente" placement="top">
                                        <button href="!#" onClick={(e) => props.handledSend(params.row.id)} id={params.row.codigo} className="btn btn-xs btn-success">
                                            <i className="nav-icon fas fa-envelope"></i>
                                        </button>
                                    </Tooltip>
                                </>
                                :
                                ""
                        }

                        {
                            props.handledSendSri
                                ?
                                <>&nbsp;&nbsp;
                                    <Tooltip title="Enviar al SRI" placement="top">
                                        <button href="!#" onClick={(e) => props.handledSendSri(params.row.id)} id={params.row.codigo} className="btn btn-xs btn-info">
                                            <i className="nav-icon fas fa-paper-plane"></i>
                                        </button>
                                    </Tooltip>
                                </>
                                :
                                ""
                        }
                    </>
                ),
            };


            setColumns(GridColumns)
        }
    }, [props]);


    return (

        <div className="row">
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    paddingRight: '0px',
                    overflowX: 'auto',
                    '& .super-app-theme--header': {
                        // backgroundColor con linear-gradient
                        color: 'rgba(75, 70, 92, 1)',
                        fontSize: '16px',
                        fontWeight: '600',
                        borderRight: '1.5px solid rgba(219, 224, 228, 1)',
                    },
                    '& .MuiDataGrid-colCell, & .MuiDataGrid-cell': {
                        borderBottom: '1.5px solid rgba(219, 224, 228, 1)',
                        borderRight: '1.5px solid rgba(219, 224, 228, 1)',
                        textAlign: 'center',
                    },
                }}
            >
                <DataGrid localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                    xs={props.width}
                    key={dataGridKey}
                    rows={rows}
                    columns={columns}
                    getRowId={(fila) => fila.id}
                    style={{ border: 'none' }}
                    initialState={{
                        ...rows.initialState,
                        pagination: { paginationModel: { pageSize: props.perPage } },
                    }}
                    hideFooterPagination={false}
                    pageSizeOptions={[5, 10, 20]}
                    autoHeight
                    headerClassName="esuper-app-theme--headr"
                    disableColumnMenu
                    className='dataGrid'
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                        },
                    }}
                />
            </Box>
        </div>

    )
}

export default InvoiceGrid
